import React from 'react';
import ErrorDisplay from '../../molecules/ErrorDisplay';

function NotFound() {
  return (
    <ErrorDisplay
      image="https://storage.googleapis.com/static-files-4fdd9378-835d-40e4-b124-36699ae5cc08/coop/not-found-guy.svg"
      title="A página que você procura não foi encontrada ..."
      description={
        <span>
          Tente verificar sua rede, se não, o endereço foi alterado
          <br />
          ou a página não está mais disponível
        </span>
      }
    />
  );
}

export default NotFound;
